
export default {
  props: {
    affiliates: {
      type: Array,
      default: () => [],
    },
  },
  computed: {
    outputAffiliates () {
      const affiliates = [...this.affiliates];
      for (let i = affiliates.length - 1; i > 0; i--) {
        const j = Math.floor(Math.random() * (i + 1));
        const temp = affiliates[i];
        affiliates[i] = affiliates[j];
        affiliates[j] = temp;
      }
      return affiliates;
    },
  },
};
